import * as React from 'react';
import './TileButton.scss';
import { CLASSNAME_PREFIX as cp } from '../../componentConfig';
import { documentStatus } from '../../constants';
function TileButton(_a) {
    var isClickable = _a.isClickable, translate = _a.t, status = _a.status, clickHandler = _a.clickHandler;
    return (React.createElement("div", { className: cp + "-tile-actions", onClick: function () { return isClickable && clickHandler(); } }, !status ? (React.createElement("span", { className: " " + cp + "-tile-actions__default" }, translate('VERIFICATION_REQUIRED_BTN_VALUE'))) : (React.createElement("span", { className: cp + "-tile-actions__status " + (isClickable ? cp + '-tile-actions__status--clickable' : '') }, translate(documentStatus[status])))));
}
export default TileButton;
//# sourceMappingURL=TileButton.js.map